import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-key',
  templateUrl: './key.component.html',
  styleUrls: ['./key.component.scss']
})
export class KeyComponent implements OnInit {

  @Input()
    keyValue: string;
  

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/shared/key/key.component.ts